/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Sheet_CloseInputs */

const id_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

const ms_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutup`)
};

const da_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk`)
};

const de_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const en_us2_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const es_es2_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const es_mx2_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const fil_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isara`)
};

const fr_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const it_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

const hu_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezárás`)
};

const nl_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

const no_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lukk`)
};

const pl_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

const pt_br2_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const pt_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

const ro_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Închidere`)
};

const fi_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje`)
};

const sv_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stäng`)
};

const vi_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng`)
};

const tr_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapat`)
};

const cs_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavřít`)
};

const bg_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Затваряне`)
};

const ru_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть`)
};

const uk_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрити`)
};

const ar_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق`)
};

const hi_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करें`)
};

const th_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปิด`)
};

const ja_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`閉じる`)
};

const zh_cn2_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const zh_hant1_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const ko_ui_sheet_close = /** @type {(inputs: Ui_Sheet_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Ui_Sheet_CloseInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const ui_sheet_close = /** @type {((inputs?: Ui_Sheet_CloseInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Sheet_CloseInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_ui_sheet_close(inputs)
	if (locale === "ms") return ms_ui_sheet_close(inputs)
	if (locale === "da") return da_ui_sheet_close(inputs)
	if (locale === "de") return de_ui_sheet_close(inputs)
	if (locale === "en-US") return en_us2_ui_sheet_close(inputs)
	if (locale === "es-ES") return es_es2_ui_sheet_close(inputs)
	if (locale === "es-MX") return es_mx2_ui_sheet_close(inputs)
	if (locale === "fil") return fil_ui_sheet_close(inputs)
	if (locale === "fr") return fr_ui_sheet_close(inputs)
	if (locale === "it") return it_ui_sheet_close(inputs)
	if (locale === "hu") return hu_ui_sheet_close(inputs)
	if (locale === "nl") return nl_ui_sheet_close(inputs)
	if (locale === "no") return no_ui_sheet_close(inputs)
	if (locale === "pl") return pl_ui_sheet_close(inputs)
	if (locale === "pt-BR") return pt_br2_ui_sheet_close(inputs)
	if (locale === "pt") return pt_ui_sheet_close(inputs)
	if (locale === "ro") return ro_ui_sheet_close(inputs)
	if (locale === "fi") return fi_ui_sheet_close(inputs)
	if (locale === "sv") return sv_ui_sheet_close(inputs)
	if (locale === "vi") return vi_ui_sheet_close(inputs)
	if (locale === "tr") return tr_ui_sheet_close(inputs)
	if (locale === "cs") return cs_ui_sheet_close(inputs)
	if (locale === "bg") return bg_ui_sheet_close(inputs)
	if (locale === "ru") return ru_ui_sheet_close(inputs)
	if (locale === "uk") return uk_ui_sheet_close(inputs)
	if (locale === "ar") return ar_ui_sheet_close(inputs)
	if (locale === "hi") return hi_ui_sheet_close(inputs)
	if (locale === "th") return th_ui_sheet_close(inputs)
	if (locale === "ja") return ja_ui_sheet_close(inputs)
	if (locale === "zh-CN") return zh_cn2_ui_sheet_close(inputs)
	if (locale === "zh-Hant") return zh_hant1_ui_sheet_close(inputs)
	return ko_ui_sheet_close(inputs)
});
export { ui_sheet_close as "ui.sheet.close" }